import { LitElement, html, css } from 'lit'

class Logotype extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
  `
  render() {
    return html`
      <svg
        width="114"
        height="41"
        viewBox="0 0 114 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_144_3440)">
          <path
            d="M108.7 9.3C111.2 9.3 113.3 7.2 113.3 4.6C113.3 2.1 111.2 0 108.7 0C106.2 0 104.1 2.1 104.1 4.6C104.1 7.2 106.2 9.3 108.7 9.3Z"
            fill="#FA1996"
          />
          <path
            d="M99.5 26H92.5C92.5 24 91.7 22.1 90.3 20.8C89 19.5 87.2 18.7 85.1 18.7C83.1 18.7 81.3 19.5 79.9 20.8C78.6 22.1 77.8 24 77.8 26H70.8C70.8 22 72.2 18.7 75 15.9C77.8 13.1 81.2 11.7 85.1 11.7C89.1 11.7 92.5 13.1 95.3 15.9C98.1 18.7 99.5 22 99.5 26Z"
            fill="#870AA0"
          />
          <path d="M49.1 26H56.1V12.1H49.1V26Z" fill="#870AA0" />
          <path d="M49.1 39.9H56.1V26H49.1V39.9Z" fill="#870AA0" />
          <path d="M21.7 39.8H28.7V12.1H21.7V39.8Z" fill="#870AA0" />
          <path d="M112.5 34.3H104.9V39.8H112.5V34.3Z" fill="#870AA0" />
          <path d="M112.5 23.2H104.9V34.3H112.5V23.2Z" fill="#FF5F0A" />
          <path d="M112.5 12.1H104.9V23.2H112.5V12.1Z" fill="#FA1996" />
          <path d="M42.7 1.10001H35.1V17.7H42.7V1.10001Z" fill="#FA1996" />
          <path
            d="M28.7 26C28.7 30 27.3 33.3 24.5 36.1C21.7 38.9 18.3 40.3 14.4 40.3C10.4 40.3 7.1 38.9 4.3 36.1C1.4 33.4 0 30 0 26C0 22 1.4 18.7 4.2 15.9L9.2 20.9C7.8 22.2 7 24 7 26C7 28 7.8 29.9 9.1 31.2C10.4 32.5 12.3 33.4 14.3 33.4C16.3 33.4 18.2 32.6 19.5 31.2C20.8 29.9 21.6 28.1 21.6 26C21.6 24 20.8 22.1 19.5 20.8C18.2 19.5 16.3 18.7 14.3 18.7V11.7C18.3 11.7 21.6 13.1 24.4 15.9C27.3 18.7 28.7 22 28.7 26Z"
            fill="#FA1996"
          />
          <path
            d="M14.4 18.7V11.7C10.4 11.7 7.09999 13.1 4.29999 15.9L9.29999 20.9C10.5 19.5 12.3 18.7 14.4 18.7Z"
            fill="#FF5F0A"
          />
          <path d="M99.5 26H92.5V39.9H99.5V26Z" fill="#FA1996" />
          <path d="M77.8 26H70.8V39.9H77.8V26Z" fill="#FA1996" />
          <path
            d="M77.8 26H70.8C70.8 24 70 22.1 68.7 20.8C67.4 19.5 65.5 18.7 63.5 18.7C61.5 18.7 59.6 19.5 58.3 20.8C57 22.2 56.1 24 56.1 26H49.1C49.1 22 50.5 18.7 53.3 15.9C56.1 13.1 59.5 11.7 63.5 11.7C67.5 11.7 70.8 13.1 73.6 15.9C76.4 18.7 77.8 22 77.8 26Z"
            fill="#FF5F0A"
          />
          <path d="M42.7 17.7H35.1V39.9H42.7V17.7Z" fill="#870AA0" />
        </g>
        <defs>
          <clipPath id="clip0_144_3440">
            <rect width="113.4" height="40.4" fill="white" />
          </clipPath>
        </defs>
      </svg>
    `
  }
}
customElements.define('almi-logotype', Logotype)
